"use client";
import React from "react";

interface AboutPremiumLayoutProps {
  children: React.ReactNode;
}

const AboutPremiumLayout: React.FC<AboutPremiumLayoutProps> = ({
  children,
}) => {
  return (
    <div>
      <section className="flex w-full bg-center bg-no-repeat bg-cover bg-[url('/Images/about-premium.jpg')] h-[194px] items-center">
        <div
          style={{
            width: "72rem",
            marginRight: "auto",
            marginLeft: "auto",
            paddingRight: "1rem",
            paddingLeft: "1rem",
          }}
        >
          <h1
            style={{
              display: "inline-block", 
              maxWidth: "40%",
              fontSize: "31.02px",
              fontWeight: "400",
            }}
          >
            UnitedHealth Premium Methodology 
          </h1>
        </div>
      </section>
      <div className="container page-container !max-w-[72rem]">{children}</div>
    </div>
  );
};

export default AboutPremiumLayout;
